import { validateEmail } from '@mindfulchefuk/forms'
import * as Yup from 'yup'

function testMatchingRecipientEmail(value: string) {
  return value === this.parent.recipientEmail
}

function testMatchingEmail(value: string) {
  return value === this.parent.email
}

const baseRecipientSchema = Yup.object({
  amount: Yup.string().required('Gift card amount is required'),
  recipientFirstName: Yup.string().required('A first name is required'),
  recipientLastName: Yup.string().required('A last name is required'),
  personalMessage: Yup.string().max(250, 'Maximum of 250 characters'),
})

const emailDeliverySchema = baseRecipientSchema.shape({
  recipientEmail: validateEmail,
  recipientEmailConfirm: Yup.string().test(
    'match',
    'Emails do not match',
    testMatchingRecipientEmail
  ),
})

export const giftCardRecipientSchema = Yup.lazy(
  ({ sendGiftCardToRecipient }) => {
    if (sendGiftCardToRecipient === 'true') {
      return emailDeliverySchema
    }

    return baseRecipientSchema
  }
)

export const giftCardPaymentSchema = Yup.object().shape({
  firstName: Yup.string().required('Your first name is required'),
  lastName: Yup.string().required('Your last name is required'),
  email: validateEmail,
  confirmEmail: Yup.mixed().test(
    'match',
    'Emails do not match',
    testMatchingEmail
  ),
  personalMessage: Yup.string().max(250, 'Must be less than 250 characters'),
})
